import React from 'react';
import {
  Button,
  Card,
  CardContent,
  Paper,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import type { Schema } from '../../services/api';
import { prettyPrint } from '../../utils/dataUtils';
import UnifiedSchemaBrowser from '../schema-view/UnifiedSchemaBrowser';

interface DraftDefinitionCardProps {
  draft: Schema;
  tablesDefinition: Record<string, unknown>;
  enrichmentMetadata: Record<string, unknown>;
}

const DraftDefinitionCard: React.FC<DraftDefinitionCardProps> = ({
  draft,
  tablesDefinition,
  enrichmentMetadata,
}) => {
  const tableCount = Object.keys(tablesDefinition).length;

  return (
    <Card variant="outlined">
      <CardContent>
        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="h6">
            Draft Definition
            {tableCount > 0 && (
              <Typography
                component="span"
                variant="body2"
                color="text.secondary"
                sx={{ ml: 1 }}
              >
                ({tableCount} tables)
              </Typography>
            )}
          </Typography>
          <Tooltip title="Download payload">
            <span>
              <Button
                component="a"
                href={`data:application/json;charset=utf-8,${encodeURIComponent(
                  JSON.stringify(draft.definition ?? {}, null, 2)
                )}`}
                download={`schema-${draft.schema_id}.json`}
                variant="outlined"
                size="small"
                startIcon={<SaveAltIcon fontSize="small" />}
              >
                Export JSON
              </Button>
            </span>
          </Tooltip>
        </Stack>
        {tableCount > 0 ? (
          <UnifiedSchemaBrowser definition={(draft.definition || {}) as any} />
        ) : (
          <Paper variant="outlined" sx={{ p: 2, maxHeight: 420, overflow: 'auto' }}>
            <pre style={{ margin: 0, fontSize: 12 }}>
              {prettyPrint(draft.definition ?? {})}
            </pre>
          </Paper>
        )}
      </CardContent>
    </Card>
  );
};

export default DraftDefinitionCard;
